/*
 * NYORD: Rubbel-Pop-up (snippets/nb-popup). Ablauf:
 * - Öffnet nach data-verzoegerung Sekunden auf der Seite. Zeit im Cookie-Dialog und in Hintergrund-Tabs zählt nicht.
 *   Am Desktop öffnet es nach 4 s schon früher, wenn die Maus die Seite oben verlässt.
 * - Öffnet nicht, wenn etwas im Warenkorb liegt (kein Pop-up über einem laufenden Kauf, Audit 14.10.2026), 5 Tage
 *   nach dem Schließen, nach einer Anmeldung, oder wenn Klaviyo die Person schon kennt (wie WHKK6w).
 * - Wischen: Maus (ohne Klicken) oder Finger über die Pfanne. Ab gut einem Drittel Fläche deckt es ganz auf.
 *   Tastatur und Bildschirmleser: „Direkt aufdecken“. Bei „Bewegung reduzieren“ ohne Blenden und Gleiten.
 * - Anmeldung über Klaviyos Client-API (öffentlicher Schlüssel, wie nb-wieder-da.js). Die Liste hat Double-Opt-in,
 *   Klaviyo schickt die Bestätigungsmail; danach kommt der Code aus dem Flow XDPigN.
 * Bewegung nur über transform und opacity (Web Animations API).
 * Vorschau: ?nb_popup=vorschau öffnet sofort und ignoriert alle Sperren.
 */
(function () {
  var wurzel = document.getElementById('nb-popup');
  if (!wurzel) return;

  var TAGE_ZU = 5;
  var RUHIG = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MAUS = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var VORSCHAU = /[?&]nb_popup=vorschau\b/.test(location.search);
  var KURVE = 'cubic-bezier(0.16, 1, 0.3, 1)';
  var verzoegerung = Math.max(3, parseInt(wurzel.dataset.verzoegerung, 10) || 10);
  var html = document.documentElement;
  var offen = false;
  var versucht = false;
  var vorbereitet = null;
  var vorherFokus = null;
  var schritt = 1;

  function merken(k, v) {
    try {
      localStorage.setItem(k, v);
    } catch (e) {}
  }
  function lesen(k) {
    try {
      return localStorage.getItem(k);
    } catch (e) {
      return null;
    }
  }
  function gesperrt() {
    if (VORSCHAU) return false;
    if (lesen('nb_popup_an')) return true;
    var zu = parseInt(lesen('nb_popup_zu'), 10);
    return !!zu && Date.now() - zu < TAGE_ZU * 864e5;
  }
  function korbVoll() {
    var d = document.querySelector('cart-drawer');
    return !!d && !d.classList.contains('is-empty');
  }
  function bewegen(el, bild, dauer, verzug) {
    if (RUHIG || !el || !el.animate) return Promise.resolve();
    var a = el.animate(bild, { duration: dauer, delay: verzug || 0, easing: KURVE, fill: 'both' });
    return a.finished.then(
      function () {
        a.cancel();
      },
      function () {}
    );
  }

  // Klaviyo kennt die Person schon (Mail geklickt, früher angemeldet): kein Pop-up, wie bei WHKK6w
  function bekannt() {
    return new Promise(function (fertig) {
      var k = window.klaviyo;
      if (VORSCHAU || !k || typeof k.isIdentified !== 'function') return fertig(false);
      var t = setTimeout(function () {
        fertig(false);
      }, 800);
      try {
        Promise.resolve(k.isIdentified()).then(
          function (j) {
            clearTimeout(t);
            fertig(!!j);
          },
          function () {
            clearTimeout(t);
            fertig(false);
          }
        );
      } catch (e) {
        clearTimeout(t);
        fertig(false);
      }
    });
  }

  // Stil und Bilder erst kurz vor dem Öffnen laden: kostet die anderen Besucher nichts
  function vorbereiten() {
    if (vorbereitet) return vorbereitet;
    var css = new Promise(function (fertig) {
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = wurzel.dataset.css;
      l.onload = l.onerror = function () {
        fertig();
      };
      document.head.appendChild(l);
    });
    var bilder = Array.prototype.map.call(wurzel.querySelectorAll('img[data-src]'), function (img) {
      return new Promise(function (fertig) {
        img.onload = img.onerror = function () {
          fertig();
        };
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
      });
    });
    var kruste = new Promise(function (fertig) {
      var k = new Image();
      k.onload = function () {
        fertig(k);
      };
      k.onerror = function () {
        fertig(null);
      };
      k.src = wurzel.querySelector('[data-nb-pop-kruste]').dataset.src;
    });
    // Schritt 1 braucht nur das saubere Foto und die Kruste; Logo und Kochbild dürfen nachladen
    vorbereitet = Promise.all([css, kruste, bilder[0], bilder[1]]).then(function (r) {
      return r[1];
    });
    return vorbereitet;
  }

  function versuchen() {
    if (versucht || offen) return;
    if (!VORSCHAU && (gesperrt() || korbVoll() || html.classList.contains('nyord-consent-offen'))) return;
    versucht = true;
    bekannt().then(function (ist) {
      if (ist || (!VORSCHAU && korbVoll())) return;
      vorbereiten().then(oeffnen);
    });
  }

  // ---------- Öffnen, Schließen, Schritte ----------
  function sichtbar(n) {
    return wurzel.querySelector('[data-nb-pop-schritt="' + n + '"]');
  }
  function oeffnen(krusteBild) {
    if (offen) return;
    offen = true;
    vorherFokus = document.activeElement;
    wurzel.hidden = false;
    html.classList.add('nb-pop-offen');
    var s = sichtbar(1);
    bewegen(wurzel, [{ opacity: 0 }, { opacity: 1 }], 500);
    var teile = s.querySelectorAll('.nb-pop__text > *');
    Array.prototype.forEach.call(teile, function (el, i) {
      bewegen(el, [{ opacity: 0, transform: 'translateY(24px)' }, { opacity: 1, transform: 'none' }], 700, 150 + i * 80);
    });
    bewegen(s.querySelector('.nb-pop__bild'), [{ opacity: 0, transform: 'scale(1.06)' }, { opacity: 1, transform: 'none' }], 1100, 100);
    rubbelStart(krusteBild);
    var titel = s.querySelector('.nb-pop__titel');
    if (titel) titel.focus({ preventScroll: true });
  }
  function schliessen() {
    if (!offen) return;
    offen = false;
    if (!lesen('nb_popup_an')) merken('nb_popup_zu', String(Date.now()));
    bewegen(wurzel, [{ opacity: 1 }, { opacity: 0 }], 300).then(function () {
      wurzel.hidden = true;
      html.classList.remove('nb-pop-offen');
      if (vorherFokus && vorherFokus.focus) vorherFokus.focus({ preventScroll: true });
    });
  }
  function zuSchritt(n) {
    var alt = sichtbar(schritt);
    var neu = sichtbar(n);
    schritt = n;
    bewegen(alt, [{ opacity: 1 }, { opacity: 0 }], 260).then(function () {
      alt.hidden = true;
      neu.hidden = false;
      bewegen(neu.querySelector('.nb-pop__bild'), [{ opacity: 0, transform: 'scale(1.05)' }, { opacity: 1, transform: 'none' }], 900);
      Array.prototype.forEach.call(neu.querySelectorAll('.nb-pop__text > *'), function (el, i) {
        bewegen(el, [{ opacity: 0, transform: 'translateY(20px)' }, { opacity: 1, transform: 'none' }], 650, i * 70);
      });
      // Am Handy nicht gleich ins Feld springen (Tastatur würde das Angebot verdecken)
      var ziel = n === 2 && MAUS ? neu.querySelector('.nb-pop__feld') : neu.querySelector('h2');
      if (ziel) ziel.focus({ preventScroll: true });
    });
  }

  wurzel.addEventListener('click', function (e) {
    if (e.target.closest('[data-nb-pop-zu]')) schliessen();
    if (e.target.closest('[data-nb-pop-aufdecken]')) aufdecken();
  });
  wurzel.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      schliessen();
      return;
    }
    if (e.key !== 'Tab') return;
    // Fokus bleibt im Dialog
    var feld = Array.prototype.filter.call(
      wurzel.querySelectorAll('button, a[href], input, [tabindex="-1"]'),
      function (el) {
        return el.offsetParent !== null && !el.closest('[hidden]') && el.getAttribute('tabindex') !== '-1';
      }
    );
    if (!feld.length) return;
    var erst = feld[0];
    var letzt = feld[feld.length - 1];
    if (e.shiftKey && (document.activeElement === erst || !wurzel.contains(document.activeElement) || document.activeElement.getAttribute('tabindex') === '-1')) {
      e.preventDefault();
      letzt.focus();
    } else if (!e.shiftKey && document.activeElement === letzt) {
      e.preventDefault();
      erst.focus();
    }
  });

  // ---------- Wischen ----------
  var flaeche = wurzel.querySelector('[data-nb-pop-rubbel]');
  var leinwand = wurzel.querySelector('[data-nb-pop-kruste]');
  var ctx = null;
  var raster = null;
  var RASTER = 24;
  var frei = 0;
  var letzter = null;
  var fertig = false;
  var pinsel = 60;
  var kruste = null;
  // Maße ohne transform (die Fläche gleitet beim Öffnen mit scale herein)
  var bw = 0;
  var bh = 0;

  function rubbelStart(bild) {
    if (bild) kruste = bild;
    if (!kruste || !leinwand.getContext) return aufdecken(true);
    bw = flaeche.offsetWidth;
    bh = flaeche.offsetHeight;
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    leinwand.width = Math.round(bw * dpr);
    leinwand.height = Math.round(bh * dpr);
    ctx = leinwand.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.globalCompositeOperation = 'source-over';
    // wie object-fit: cover mit der object-position aus dem CSS (--nb-pop-x / --nb-pop-y)
    var stil = getComputedStyle(flaeche);
    var px = parseFloat(stil.getPropertyValue('--nb-pop-x')) / 100;
    var py = parseFloat(stil.getPropertyValue('--nb-pop-y')) / 100;
    if (isNaN(px)) px = 0.5;
    if (isNaN(py)) py = 0.5;
    var s = Math.max(bw / kruste.naturalWidth, bh / kruste.naturalHeight);
    var w = kruste.naturalWidth * s;
    var h = kruste.naturalHeight * s;
    ctx.drawImage(kruste, (bw - w) * px, (bh - h) * py, w, h);
    ctx.globalCompositeOperation = 'destination-out';
    pinsel = Math.max(44, Math.min(110, bw * 0.15));
    raster = new Uint8Array(RASTER * RASTER);
    frei = 0;
    flaeche.classList.add('nb-pop__rubbel--bereit');
  }
  // Fenstergröße ändert sich (Handy gedreht): Kruste neu auflegen, solange noch nicht aufgedeckt
  var groesse = null;
  window.addEventListener('resize', function () {
    if (!offen || fertig || !ctx) return;
    clearTimeout(groesse);
    groesse = setTimeout(function () {
      if (flaeche.offsetWidth !== bw || flaeche.offsetHeight !== bh) rubbelStart();
    }, 150);
  });

  function tupfen(x, y) {
    var g = ctx.createRadialGradient(x, y, 0, x, y, pinsel);
    g.addColorStop(0, 'rgba(0,0,0,1)');
    g.addColorStop(0.6, 'rgba(0,0,0,0.9)');
    g.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = g;
    ctx.beginPath();
    ctx.arc(x, y, pinsel, 0, Math.PI * 2);
    ctx.fill();
    // Fortschritt grob über ein Raster zählen statt Pixel auszulesen
    var zw = bw / RASTER;
    var zh = bh / RASTER;
    var rad = pinsel * 0.7;
    for (var i = Math.max(0, Math.floor((x - rad) / zw)); i <= Math.min(RASTER - 1, Math.floor((x + rad) / zw)); i++) {
      for (var j = Math.max(0, Math.floor((y - rad) / zh)); j <= Math.min(RASTER - 1, Math.floor((y + rad) / zh)); j++) {
        var cx = (i + 0.5) * zw - x;
        var cy = (j + 0.5) * zh - y;
        if (cx * cx + cy * cy <= rad * rad && !raster[j * RASTER + i]) {
          raster[j * RASTER + i] = 1;
          frei++;
        }
      }
    }
  }

  function wischen(e) {
    if (fertig || !ctx || schritt !== 1) return;
    var r = flaeche.getBoundingClientRect();
    var x = ((e.clientX - r.left) * bw) / r.width;
    var y = ((e.clientY - r.top) * bh) / r.height;
    if (letzter) {
      var dx = x - letzter.x;
      var dy = y - letzter.y;
      var weg = Math.sqrt(dx * dx + dy * dy);
      var schritte = Math.max(1, Math.ceil(weg / (pinsel * 0.3)));
      for (var k = 1; k <= schritte; k++) tupfen(letzter.x + (dx * k) / schritte, letzter.y + (dy * k) / schritte);
    } else {
      tupfen(x, y);
    }
    letzter = { x: x, y: y };
    if (frei / (RASTER * RASTER) > 0.36) aufdecken();
  }
  leinwand.addEventListener('pointerdown', function (e) {
    letzter = null;
    if (e.pointerType !== 'mouse') leinwand.setPointerCapture(e.pointerId);
    wischen(e);
  });
  leinwand.addEventListener('pointermove', function (e) {
    // Maus wischt schon beim Drüberfahren, Finger und Stift beim Ziehen
    if (e.pointerType === 'mouse' || e.buttons || e.pressure > 0) wischen(e);
  });
  leinwand.addEventListener('pointerleave', function () {
    letzter = null;
  });
  leinwand.addEventListener('pointerup', function () {
    letzter = null;
  });

  function aufdecken(sofort) {
    if (fertig) return;
    fertig = true;
    flaeche.classList.add('nb-pop__rubbel--frei');
    var fund = flaeche.querySelector('.nb-pop__fund');
    bewegen(leinwand, [{ opacity: 1 }, { opacity: 0 }], 600).then(function () {
      leinwand.hidden = true;
    });
    bewegen(fund, [{ transform: 'scale(0.92)' }, { transform: 'scale(1.04)' }, { transform: 'none' }], 900, 200);
    setTimeout(
      function () {
        if (schritt === 1 && offen) zuSchritt(2);
      },
      sofort === true || RUHIG ? 900 : 1700
    );
  }

  // ---------- Anmelden ----------
  var form = wurzel.querySelector('[data-nb-pop-form]');
  var feld = form.querySelector('.nb-pop__feld');
  var knopf = form.querySelector('.nb-pop__knopf');
  var meldung = form.querySelector('.nb-pop__meldung');
  var knopfText = knopf.textContent;

  function melden(text) {
    meldung.textContent = text || '';
    meldung.hidden = !text;
    feld.setAttribute('aria-invalid', text ? 'true' : 'false');
  }
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = feld.value.trim();
    if (!email || !feld.checkValidity() || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      melden(wurzel.dataset.textEmail);
      feld.focus();
      return;
    }
    melden('');
    knopf.disabled = true;
    knopf.textContent = wurzel.dataset.textWarten;
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + wurzel.dataset.firma, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2025-01-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'NYORD Pop-up Rubbeln',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: { 'NYORD Sprache': 'de' },
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                },
              },
            },
          },
          relationships: { list: { data: { type: 'list', id: wurzel.dataset.liste } } },
        },
      }),
    })
      .then(function (antwort) {
        if (!antwort.ok) throw new Error(String(antwort.status));
        merken('nb_popup_an', '1');
        wurzel.querySelector('[data-nb-pop-adresse]').textContent = email;
        try {
          if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email });
        } catch (err) {}
        zuSchritt(3);
      })
      .catch(function () {
        melden(wurzel.dataset.textFehler);
      })
      .then(function () {
        knopf.disabled = false;
        knopf.textContent = knopfText;
      });
  });

  // ---------- Auslöser ----------
  if (VORSCHAU) {
    versuchen();
    return;
  }
  if (gesperrt()) return;
  var aktiv = 0;
  var takt = setInterval(function () {
    if (document.hidden || html.classList.contains('nyord-consent-offen')) return;
    aktiv += 0.5;
    if (aktiv >= verzoegerung - 3) vorbereiten();
    if (aktiv >= verzoegerung) {
      clearInterval(takt);
      versuchen();
    }
  }, 500);
  if (MAUS) {
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0 && aktiv >= 4) {
        clearInterval(takt);
        versuchen();
      }
    });
  }
})();
